import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TableDesktop from './TableDesktop';
import TableMobile from './TableMobile';
import NoWithdrawalsYet from './NoWithdrawalsYet';
import styles from './index.module.css';

const WithdrawalHistoryTable = ({ withdrawals }) => {
  const hasWithdrawals = withdrawals.length > 0;

  return (
    <div className={styles.root}>
      <div
        className={classNames(styles.tableWrapper, {
          [styles.empty]: !hasWithdrawals,
        })}
      >
        {hasWithdrawals ? (
          <>
            <TableDesktop withdrawals={withdrawals} />
            <TableMobile withdrawals={withdrawals} />
          </>
        ) : (
          <NoWithdrawalsYet />
        )}
      </div>
    </div>
  );
};

WithdrawalHistoryTable.propTypes = {
  withdrawals: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      wallet: PropTypes.string.isRequired,
      network: PropTypes.string.isRequired,
      amount: PropTypes.shape({
        value: PropTypes.string.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
      convertedAmount: PropTypes.shape({
        value: PropTypes.string.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
      status: PropTypes.string.isRequired,
    })
  ),
};

WithdrawalHistoryTable.defaultProps = {
  withdrawals: [],
};

export default WithdrawalHistoryTable;
